export const WALLET_ADAPTER_CORE_VERSION = "3.16.0";
